<app-dialog-wrapper>
  <form class="meal" #formElement="ngForm" [formGroup]="form">
    @let variantImage = selectedVariant()?.main_image?.url;
    @let fallbackImage = product | productImage;
    @let image = variantImage || fallbackImage;
    @if (image) {
      <img
        [src]="image"
        loading="lazy"
        [alt]="selectedVariant()?.name || product.name"
        onerror="onerror=null;src='assets/images/image-placeholder.svg';"
        class="meal__img"
      />
    }

    <div class="meal__header">
      <div class="meal__header__title">
        <div class="meal__header__name" [innerHTML]="product.name"></div>
        <div class="meal__header__details">
          @if (product.average_rating != '0') {
            <div class="meal__header__rating">
              <i class="icon-star"></i>
              <p>{{ product.average_rating }}</p>
            </div>
          }
        </div>
      </div>
      <div class="meal__header__price">
        @let isDiscounted =
          productPrices().regular_price > productPrices().price;
        @let minorUnit = productPrices().currency_minor_unit;

        <span class="meal__price--final">
          {{ totalPrice() | formattedCurrency: minorUnit }}
        </span>
        <p>
          @if (isDiscounted) {
            <span class="meal__price--line-through">
              {{ productPrices().regular_price | formattedCurrency: minorUnit }}
            </span>
            <!--                  TODO: Need API -->
            @if (discountPercentage()) {
              <span class="meal__price__discount">
                {{ discountPercentage() | number:'.0-0' }}% OFF
              </span>
            }
          }
        </p>
      </div>
    </div>

    @if (processedDescription()) {
      <div class="meal__description" [innerHtml]="processedDescription()"></div>
    }

    @if (hasVariants) {
      <div class="meal__variants" [class.meal__variants--invalid]="variantSelectionInvalid()">
        <h6 class="meal__options__group__title group-title required" [class.invalid]="variantSelectionInvalid()">
          Size
          <span class="group-title__required">* (Selection required)</span>
        </h6>
        <ul class="meal__variants__list">
          @for (variant of productVariants; track variant.id) {
            <li>
              <button
                type="button"
                class="meal__variants__btn"
                [class.meal__variants__btn--selected]="selectedVariant()?.id === variant.id"
                [class.meal__variants__btn--out-of-stock]="!variant.is_in_stock"
                [disabled]="!variant.is_in_stock"
                (click)="selectVariant(variant)"
              >
                <span class="meal__variants__btn__label">{{ getVariantLabel(variant) }}</span>
                <span class="meal__variants__btn__price">
                  {{ variant.effective_price | currency: 'USD' : '$' : '1.2-2' }}
                </span>
              </button>
            </li>
          }
        </ul>
      </div>
    }

    @if (rootAddons.length > 0) {

      <fieldset formGroupName="addons_configuration" class="meal__options">
        <!-- Template for rendering sub-addons - must be inside formGroupName context -->
        <ng-template #subAddonTemplate let-subAddon>
          <!--          @let subFormControlName = ADD_ON_PREFIX + subAddon.field_name;-->
          <!--          @let subFormControlName = subAddon.key + '';-->
          @let subFormControl = addOnsForm.get(subAddon.key);
          @let subIsInvalid = formElement['submitted'] && !!subFormControl?.invalid;

          <div class="meal__options__group meal__options__group--sub-addon">
            <h6
              class="meal__options__group__title group-title"
              [class.invalid]="subIsInvalid"
              [class.required]="subAddon.required"
            >
              {{ subAddon.name }}

              <span class="group-title__required">
                @if (subAddon.required && subAddon.max_options !== 0) {
                  * (At least one selection is required. You may choose up to
                  {{ subAddon.max_options }} selection{{ subAddon.max_options > 1 ? 's' : '' }})
                } @else if (!subAddon.required && subAddon.max_options === 1) {
                  You may only select one.
                } @else if (!subAddon.required && subAddon.max_options > 1) {
                  You may select up to {{ subAddon.max_options }} selections.
                } @else if (subAddon.required) {
                  * (At least one selection is required)
                }
              </span>
            </h6>

            <span class="meal__options__group__subtitle">
              {{ subAddon.description }}
            </span>

            @if (subAddon.type === WooCommerceProductAddonType.CustomText) {
              <app-input [formControlName]="subAddon.key" />
            } @else if (subAddon.type === WooCommerceProductAddonType.CustomTextarea) {
              <app-textarea [formControlName]="subAddon.key" />
            } @else if (subAddon.type === WooCommerceProductAddonType.MultipleChoice &&
            subAddon.display === WooCommerceProductAddonDisplay.Select) {
              <app-dropdown
                optionValueName="value"
                [isArray]="false"
                [formControlName]="subAddon.key"
                [options]="subAddon.options"
                [size]="DropdownSize.Big"
                [style]="DropdownStyle.Secondary"
                [showOptionPrice]="true"
              />

              @if (subAddon.slug) {
                @for (option of subAddon.options; track optionIdx; let optionIdx = $index) {
                  @if (isOptionSelected(subAddon, optionIdx)) {
                    @for (nestedSub of getSubAddonsForOption(subAddon.slug, optionIdx); track nestedSub.field_name) {
                      <ng-container
                        *ngTemplateOutlet="subAddonTemplate; context: { $implicit: nestedSub }"
                      ></ng-container>
                    }
                  }
                }
              }
            } @else if (subAddon.type === WooCommerceProductAddonType.MultipleChoice &&
            subAddon.display === WooCommerceProductAddonDisplay.RadioButton &&
            subAddon.max_options > 1) {
              <ng-template #checkboxItemRadio let-item let-i="index">
                @if (subAddon.slug && isOptionSelected(subAddon, i)) {
                  @for (nestedSub of getSubAddonsForOption(subAddon.slug, i); track nestedSub.field_name) {
                    <ng-container
                      *ngTemplateOutlet="subAddonTemplate; context: { $implicit: nestedSub }"
                    ></ng-container>
                  }
                }
              </ng-template>

              <app-checkbox-list
                checkboxLabelName="label"
                checkboxValueName="value"
                [invalid]="subIsInvalid"
                [name]="subAddon.field_name"
                [checkboxes]="subAddon.options"
                [formControlName]="subAddon.key"
                [maxSelectable]="subAddon.max_options"
                listClass="radio-list"
                itemClass="radio-list__option"
                priceClass="radio-list__option_price"
                [itemTemplate]="checkboxItemRadio"
              />
            } @else if (subAddon.type === WooCommerceProductAddonType.MultipleChoice &&
            subAddon.display === WooCommerceProductAddonDisplay.RadioButton) {
              <ul class="meal__options__group_radio radio-list">
                @for (option of subAddon.options; track $index) {
                  <div class="radio-list__option">
                    <div class="radio-list__option_control">
                      <app-radio
                        [isArray]="false"
                        [formControlName]="subAddon.key"
                        [label]="option.label"
                        [name]="subAddon.field_name"
                        [radioValue]="option.value"
                      />
                    </div>

                    @if (option.price) {
                      <span class="radio-list__option_price">
                        +{{ option.price | currency: 'USD' : '$' : '1.0-2' }}
                      </span>
                    }
                  </div>

                  @if (subAddon.slug && isOptionSelected(subAddon, $index)) {
                    @for (nestedSub of getSubAddonsForOption(subAddon.slug, $index); track nestedSub.field_name) {
                      <ng-container
                        *ngTemplateOutlet="subAddonTemplate; context: { $implicit: nestedSub }"
                      ></ng-container>
                    }
                  }
                }
              </ul>
            } @else if (subAddon.type === WooCommerceProductAddonType.Checkbox) {
              <ng-template #checkboxItemCheckbox let-item let-i="index">
                @if (subAddon.slug && isOptionSelected(subAddon, i)) {
                  @for (nestedSub of getSubAddonsForOption(subAddon.slug, i); track nestedSub.field_name) {
                    <ng-container
                      *ngTemplateOutlet="subAddonTemplate; context: { $implicit: nestedSub }"
                    ></ng-container>
                  }
                }
              </ng-template>

              <app-checkbox-list
                checkboxLabelName="label"
                checkboxValueName="value"
                [invalid]="subIsInvalid"
                [name]="subAddon.field_name"
                [checkboxes]="subAddon.options"
                [formControlName]="subAddon.key"
                [maxSelectable]="subAddon.max_options"
                [itemTemplate]="checkboxItemCheckbox"
              />
            }
          </div>
        </ng-template>

        @for (optionsGroup of rootAddons; track $index) {
          <!--          @let formControlName = ADD_ON_PREFIX + optionsGroup.field_name;-->
          @let formControl = addOnsForm.get(optionsGroup.key);
          @let isInvalid = formElement['submitted'] && !!formControl?.invalid;

          <div class="meal__options__group">
            <h6
              class="meal__options__group__title group-title"
              [class.invalid]="isInvalid"
              [class.required]="optionsGroup.required"
            >
              {{ optionsGroup.name }}

              <span class="group-title__required">
                @if (optionsGroup.required && optionsGroup.max_options !== 0) {
                  * (At least one selection is required. You may choose up to
                  {{ optionsGroup.max_options }} selection{{ optionsGroup.max_options > 1 ? 's' : '' }})
                } @else if (!optionsGroup.required && optionsGroup.max_options === 1) {
                  You may only select one.
                } @else if (!optionsGroup.required && optionsGroup.max_options > 1) {
                  You may select up to {{ optionsGroup.max_options }} selections.
                } @else if (optionsGroup.required) {
                  * (At least one selection is required)
                }
              </span>
            </h6>

            <span class="meal__options__group__subtitle">
              {{ optionsGroup.description }}
            </span>

            @if (optionsGroup.type === WooCommerceProductAddonType.CustomText) {
              <app-input [formControlName]="optionsGroup.key" />
            } @else if (optionsGroup.type === WooCommerceProductAddonType.CustomTextarea) {
              <app-textarea [formControlName]="optionsGroup.key" />
            } @else if (optionsGroup.type === WooCommerceProductAddonType.MultipleChoice &&
            optionsGroup.display === WooCommerceProductAddonDisplay.Select) {
              <app-dropdown
                optionValueName="value"
                [isArray]="false"
                [formControlName]="optionsGroup.key"
                [options]="optionsGroup.options"
                [size]="DropdownSize.Big"
                [style]="DropdownStyle.Secondary"
                [showOptionPrice]="true"
              />

              @if (optionsGroup.slug) {
                @for (option of optionsGroup.options; track optionIdx; let optionIdx = $index) {
                  @if (isOptionSelected(optionsGroup, optionIdx)) {
                    @for (subAddon of getSubAddonsForOption(optionsGroup.slug, optionIdx); track subAddon.field_name) {
                      <ng-container
                        *ngTemplateOutlet="subAddonTemplate; context: { $implicit: subAddon }"
                      ></ng-container>
                    }
                  }
                }
              }
            } @else if (optionsGroup.type === WooCommerceProductAddonType.MultipleChoice &&
            optionsGroup.display === WooCommerceProductAddonDisplay.RadioButton &&
            optionsGroup.max_options > 1) {
              <ng-template #rootCheckboxItemRadio let-item let-i="index">
                @if (optionsGroup.slug && isOptionSelected(optionsGroup, i)) {
                  @for (subAddon of getSubAddonsForOption(optionsGroup.slug, i); track subAddon.field_name) {
                    <ng-container
                      *ngTemplateOutlet="subAddonTemplate; context: { $implicit: subAddon }"
                    ></ng-container>
                  }
                }
              </ng-template>

              <app-checkbox-list
                checkboxLabelName="label"
                checkboxValueName="value"
                [invalid]="isInvalid"
                [name]="optionsGroup.field_name"
                [checkboxes]="optionsGroup.options"
                [formControlName]="optionsGroup.key"
                [maxSelectable]="optionsGroup.max_options"
                listClass="radio-list"
                itemClass="radio-list__option"
                priceClass="radio-list__option_price"
                [itemTemplate]="rootCheckboxItemRadio"
              />
            } @else if (optionsGroup.type === WooCommerceProductAddonType.MultipleChoice &&
            optionsGroup.display === WooCommerceProductAddonDisplay.RadioButton) {
              <ul class="meal__options__group_radio radio-list">
                @for (option of optionsGroup.options; track optionIndex; let optionIndex = $index) {
                  <div class="radio-list__option">
                    <div class="radio-list__option_control">
                      <app-radio
                        [isArray]="false"
                        [formControlName]="optionsGroup.key"
                        [label]="option.label"
                        [name]="optionsGroup.field_name"
                        [radioValue]="option.value"
                      />
                    </div>

                    @if (option.price) {
                      <span class="radio-list__option_price">
                        +{{ option.price | currency: 'USD' : '$' : '1.0-2' }}
                      </span>
                    }
                  </div>

                  <!-- Sub-addons for this option (radio button case) -->
                  @if (optionsGroup.slug && isOptionSelected(optionsGroup, optionIndex)) {
                    @for (subAddon of getSubAddonsForOption(optionsGroup.slug, optionIndex); track subAddon.field_name) {
                      <ng-container
                        *ngTemplateOutlet="subAddonTemplate; context: { $implicit: subAddon }"
                      ></ng-container>
                    }
                  }
                }
              </ul>
            } @else if (optionsGroup.type === WooCommerceProductAddonType.Checkbox) {
              <ng-template #rootCheckboxItemCheckbox let-item let-i="index">
                @if (optionsGroup.slug && isOptionSelected(optionsGroup, i)) {
                  @for (subAddon of getSubAddonsForOption(optionsGroup.slug, i); track subAddon.field_name) {
                    <ng-container
                      *ngTemplateOutlet="subAddonTemplate; context: { $implicit: subAddon }"
                    ></ng-container>
                  }
                }
              </ng-template>

              <app-checkbox-list
                checkboxLabelName="label"
                checkboxValueName="value"
                [invalid]="isInvalid"
                [name]="optionsGroup.field_name"
                [checkboxes]="optionsGroup.options"
                [formControlName]="optionsGroup.key"
                [maxSelectable]="optionsGroup.max_options"
                [itemTemplate]="rootCheckboxItemCheckbox"
              />
            }
          </div>
        }
      </fieldset>
    }
  </form>

  <div footer class="meal__footer">
    <app-counter
      [formControl]="$any(form.controls['quantity'])"
      [min]="1"
      [max]="20"
    />

    <app-button
      type="submit"
      class="meal__add-btn"
      [loading]="isAddToCartLoading()"
      [style]="ButtonStyle.Primary"
      (buttonClick)="onAddToCartClick(); formElement['submitted'] = true"
    >
      Add to Cart
    </app-button>
  </div>
</app-dialog-wrapper>
